import './App.css';
import 'remixicon/fonts/remixicon.css';
import Fullpage from './pages/fullpage/Fullpage';

function App() {
  return (
    <div className='element'>
      <Fullpage></Fullpage>
    </div>
  );
}

export default App;
